import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "spacer",
  style: {"margin-bottom":"60px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contentBlock = _resolveComponent("contentBlock")!
  const _component_promoCard = _resolveComponent("promoCard")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_menuItemCard = _resolveComponent("menuItemCard")!
  const _component_gridContainer = _resolveComponent("gridContainer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_gridContainer, {
        backBtn: _ctx.isMobile,
        backText: "Menu",
        loading: !_ctx.isLocationReady
      }, {
        default: _withCtx(() => [
          (_ctx.fullMenu)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_promoCard, { class: "promo-header" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_contentBlock, {
                              style: {"padding-top":"20px","padding-bottom":"20px"},
                              backupText: `<h3 class='pb-8'>Decisions, Decisions…</h3> <h5>There's so much to love, you can't go wrong.</h5>`,
                              slug: 'menu-category-' + _ctx.category + '-10'
                            }, null, 8, ["slug"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!_ctx.isMobile)
                  ? (_openBlock(), _createBlock(_component_ion_row, {
                      key: 0,
                      class: "category-links my-8 ion-padding-bottom ion-justify-content-center"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedMenuCategories, (category) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: category.name
                          }, [
                            (category.use_base_url)
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.router.replace('/' + category.path)),
                                  fill: "clear",
                                  size: "small",
                                  class: "bold",
                                  color: '/' + category.path === _ctx.$route.path ? 'dark' : 'primary'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(category.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "color"]))
                              : (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.router.replace('/menu/' + category.path)),
                                  fill: "clear",
                                  size: "small",
                                  class: "bold",
                                  color: '/menu/' + category.path === _ctx.$route.path ? 'dark' : 'primary'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(category.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "color"]))
                          ], 64))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.topMenu?.length > 0)
                  ? (_openBlock(), _createBlock(_component_ion_row, {
                      key: 1,
                      class: "ion-justify-content-center mt-4 ion-margin-bottom",
                      "data-cy": "classic-menu"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topMenu, (item, i) => {
                          return (_openBlock(), _createBlock(_component_ion_col, {
                            key: i,
                            size: _ctx.isMobile ? 12 : 3
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_component_menuItemCard, {
                                item: item,
                                category: _ctx.category,
                                key: _ctx.refresherKey,
                                class: "menu-item",
                                detail: ""
                              }, null, 8, ["item", "category"]))
                            ]),
                            _: 2
                          }, 1032, ["size"]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.topMenu?.length > 0)
                  ? (_openBlock(), _createBlock(_component_ion_row, { key: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("h2", null, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.category == 'pizza' ? 'Signature Pizzas' : 'Entree & Party Sizes'), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.bottomMenu)
                  ? (_openBlock(), _createBlock(_component_ion_row, {
                      key: 3,
                      class: "ion-justify-content-center",
                      "data-cy": "regular-menu"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bottomMenu, (item, i) => {
                          return (_openBlock(), _createBlock(_component_ion_col, {
                            key: i,
                            size: _ctx.isMobile ? 12 : 3,
                            class: "my-4"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_component_menuItemCard, {
                                item: item,
                                category: _ctx.category,
                                key: _ctx.refresherKey,
                                class: "menu-item",
                                detail: "",
                                "data-cy": 'menu-item-' + item.path
                              }, null, 8, ["item", "category", "data-cy"]))
                            ]),
                            _: 2
                          }, 1032, ["size"]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isMobile && _ctx.cartCount > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["backBtn", "loading"]),
      (_ctx.isMobile && _ctx.cartCount > 0)
        ? (_openBlock(), _createBlock(_component_ion_row, {
            key: 0,
            class: "ion-no-margin force-bottom full-width"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_button, {
                color: "primary",
                expand: "full",
                class: "ion-no-margin force-bottom full-width",
                style: {"font-size":"1.3em"},
                onClick: _ctx.goToCart,
                size: "large"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("Begin Checkout")
                ])),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}